import { subtitles } from "../data/sampleSubs";

/**
 * Initial state for game reducer
 */
export const initialState = {
  subtitles,
  activeSubtitleIndex: 0,
  name: false,
  flagsRemaining: 5,
};

/**
 *
 *
 * @see useReducer
 *
 * @param {Object} initialValue
 * @returns Initial state for reducer
 */
export const initializer = (initialValue = initialState) =>
  JSON.parse(localStorage.getItem("localGame")) || initialValue;

/**
 * Reducer for actions related to room data in RoomsProvider. Used by
 * useReducer() in RoomsProvider as reducer function.
 *
 * @param {Object} state
 * @param {Object} action
 * @returns Reducer function
 */
export const gameReducer = (state, action) => {
  switch (action.type) {
    case "SET_ACTIVE_SUBTITLE_INDEX":
      return {
        ...state,
        activeSubtitleIndex: action.payload,
      };
    case "FLAG_ACTIVE_SUBTITLE_INDEX":
      return {
        ...state,
        subtitles: [
          ...state.subtitles.slice(0, state.activeSubtitleIndex),
          {
            ...state.subtitles[state.activeSubtitleIndex],
            flagged: !state.subtitles[state.activeSubtitleIndex].flagged,
          },
          ...state.subtitles.slice(state.activeSubtitleIndex + 1),
        ],
      };
    case "RESET_GAME":
      return initialState;
    case "SET_NAME":
      return {
        ...state,
        name: action.payload,
      };
    default:
      throw new Error();
  }
};

/**
 *
 * @see gameReducer
 *
 * @param {string} id
 * @param {Object} rooms
 * @returns Action object
 */
export const setActiveSubtitleIndex = (activeSubtitleIndex) => ({
  type: "SET_ACTIVE_SUBTITLE_INDEX",
  payload: activeSubtitleIndex,
});

/**
 *
 * @see gameReducer
 *
 * @param {string} id
 * @param {Object} rooms
 * @returns Action object
 */
export const flagActiveSubtitleIndex = () => ({
  type: "FLAG_ACTIVE_SUBTITLE_INDEX",
});

/**
 *
 * @see gameReducer
 *
 * @param {string} id
 * @param {Object} rooms
 * @returns Action object
 */
export const resetGame = () => ({
  type: "RESET_GAME",
});

/**
 *
 * @see gameReducer
 *
 * @param {string} id
 * @param {Object} rooms
 * @returns Action object
 */
export const setName = (name) => ({
  type: "SET_NAME",
  payload: name,
});
